import axios from 'axios'

import { Message } from 'element-ui'

const http = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 1000 * 30,
	withCredentials: true
})

http.interceptors.request.use(config => {
	let accessToken = sessionStorage.getItem("accessToken");
	if (accessToken) {
		config.headers.accessToken = encodeURIComponent(accessToken);
	}

	if (config.url && config.url.startsWith('/admin')) {
		let adminToken = localStorage.getItem('adminToken');
		if (adminToken) {
			config.headers['Admin-Token'] = adminToken;
		}
	}
	return config
}, error => {
	return Promise.reject(error)
})

http.interceptors.response.use(async response => {
	if (response.data.code == 200) {
		return response.data.data;
	} else if (response.data.code == 400) {
		location.href = "/";
	} else if (response.data.code == 401) {
		console.log("token失效，尝试重新获取")
		let refreshToken = sessionStorage.getItem("refreshToken");
		if (!refreshToken) {
			location.href = "/";
		}
		const data = await http({
			method: 'put',
			url: '/refreshToken',
			headers: {
				refreshToken: refreshToken
			}
		}).catch(() => {
			location.href = "/";
		})
		sessionStorage.setItem("accessToken", data.accessToken);
		sessionStorage.setItem("refreshToken", data.refreshToken);
		return http(response.config)
	} else {
		Message({
			message: response.data.message,
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(response.data)
	}
}, error => {
	if (error.response) {
		switch (error.response.status) {
			case 400:
				Message({
					message: error.response.data,
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
			case 401:
				if (error.config && error.config.url && error.config.url.startsWith('/admin') && !error.config.url.startsWith('/admin/login')) {
					localStorage.removeItem('adminToken');
					location.href = "/#/im_admin/login";
				} else {
					location.href = "/";
				}
				break
			case 405:
				Message({
					message: 'http请求方式有误',
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
			case 404:
			case 500:
				Message({
					message: '服务器出了点小差，请稍后再试',
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
			case 501:
				Message({
					message: '服务器不支持当前请求所需要的某个功能',
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
		}
	} else {
		Message({
			message: '网络错误，请检查网络连接',
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
	}

	return Promise.reject(error)
})


export default http